import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import Sheet from 'components/utils/Sheet'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useLuxPlusLandingActions from 'luxPlus/hooks/useLuxPlusLandingActions'
import useShouldShowMembershipCta from 'luxPlus/hooks/useShouldShowMembershipCta'
import { getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import { useAppSelector } from 'hooks/reduxHooks'

const BottomCTASheet = styled(Sheet)`
  background: linear-gradient(90deg, #304DAB 0%, #4C82DF 100%);
  padding: ${rem(64)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(64)} ${rem(20)};
  }
`

const BottomCTAContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(24)};
`

const BottomCTAButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

function LuxPlusLandingBottomCTA() {
  const intl = useIntl()
  const { handleBecomeMember, handleStartFreePreview } = useLuxPlusLandingActions()
  const showCta = useShouldShowMembershipCta()
  const isPreview = useAppSelector(getIsFreePreviewLuxPlusMember)

  const headingText = intl.formatMessage({
    id: 'lG7Ukbu6MA9m4Q9UIR9l',
    defaultMessage: 'Ready to travel like a VIP?',
    description: 'Heading for bottom CTA section on LuxPlus landing page',
  })
  const subheadingText = intl.formatMessage({
    id: 'n3sPwZQti_cycmmy0vNN',
    defaultMessage: 'Join thousands of members and start saving on your next escape',
    description: 'Subheading for bottom CTA section on LuxPlus landing page',
  })
  const becomeMemberLabel = intl.formatMessage({
    id: 'gOmG-993oL_TeV7rEEH6',
    defaultMessage: 'Become a member',
    description: 'Button to join LuxPlus membership on landing page bottom CTA',
  })
  const freePreviewLabel = intl.formatMessage({
    id: 'lvo3wLJLEBEDArlNqjdo',
    defaultMessage: 'Start 28-day free preview',
    description: 'Button to start free LuxPlus preview on landing page bottom CTA',
  })

  if (!showCta) return null

  return (
    <CSSBreakpoint min="tablet">
      <BottomCTASheet paletteType="inverse">
        <BottomCTAContent>
          <Group direction="vertical" gap={8} horizontalAlign="center">
            <HeadingTextBlock variant="heading3" align="center">
              {headingText}
            </HeadingTextBlock>
            <BodyText variant="medium" colour="neutral-one" align="center">
              {subheadingText}
            </BodyText>
          </Group>
          <BottomCTAButtons>
            <TextButton kind="primary" onClick={handleBecomeMember}>
              {becomeMemberLabel}
            </TextButton>
            {!isPreview && (
              <TextButton kind="secondary" onClick={handleStartFreePreview}>
                {freePreviewLabel}
              </TextButton>
            )}
          </BottomCTAButtons>
        </BottomCTAContent>
      </BottomCTASheet>
    </CSSBreakpoint>
  )
}

export default LuxPlusLandingBottomCTA
